import { EmployeeCustomTablesCustomValueFragment } from 'generated/resources/graphql'

const coerceToNumber = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const numValue = typeof value === 'number' ? value : Number(value)

  if (Number.isNaN(numValue)) {
    return null
  }

  return numValue
}

export const coerceValueFromType = (
  customValue: EmployeeCustomTablesCustomValueFragment,
  fieldType: string
) => {
  switch (fieldType) {
    case 'cents':
    case 'money':
      return coerceToNumber(customValue.centsValue)
    case 'rating':
      return customValue.numberValue
    case 'text':
    case 'long_text':
      return customValue.longTextValue
    case 'date':
      return customValue.dateValue
    case 'checkbox':
      return customValue.booleanValue
    case 'single_choice':
      return customValue.singleChoiceValue
    case 'multiple_choice':
      return customValue.multipleChoiceValue
  }
}
